// Country Flag Emoji Utility
// Maps country names to their flag emojis

const countryFlagMap = {
  // Most common countries
  Albania: '🇦🇱',
  Mexico: '🇲🇽',
  Peru: '🇵🇪',
  Ukraine: '🇺🇦',
  Ireland: '🇮🇪',
  'South Africa': '🇿🇦',
  Montenegro: '🇲🇪',
  Eswatini: '🇸🇿',
  Hungary: '🇭🇺',
  Spain: '🇪🇸',
  'North Macedonia': '🇲🇰',
  Andorra: '🇦🇩',
  Moldova: '🇲🇩',
  'South Georgia and the South Sandwich Islands': '🇬🇸',
  Georgia: '🇬🇪',
  Germany: '🇩🇪',
  Libya: '🇱🇾',
  Laos: '🇱🇦',
  'Saint Lucia': '🇱🇨',
  Guinea: '🇬🇳',
  'Democratic Republic C': '🇨🇩',
  China: '🇨🇳',
  Belarus: '🇧🇾',
  Poland: '🇵🇱',
  Finland: '🇫🇮',
  Czechia: '🇨🇿',
  Guyana: '🇬🇾',
  Jersey: '🇯🇪',
  Taiwan: '🇹🇼',
  Venezuela: '🇻🇪',
  Argentina: '🇦🇷',
  Brazil: '🇧🇷',
  Chile: '🇨🇱',
  Colombia: '🇨🇴',
  Ecuador: '🇪🇨',
  Paraguay: '🇵🇾',
  Uruguay: '🇺🇾',
  'United States': '🇺🇸',
  'United Kingdom': '🇬🇧',
  France: '🇫🇷',
  Italy: '🇮🇹',
  Netherlands: '🇳🇱',
  Belgium: '🇧🇪',
  Portugal: '🇵🇹',
  Greece: '🇬🇷',
  Sweden: '🇸🇪',
  Norway: '🇳🇴',
  Denmark: '🇩🇰',
  Switzerland: '🇨🇭',
  Austria: '🇦🇹',
  Romania: '🇷🇴',
  Bulgaria: '🇧🇬',
  Serbia: '🇷🇸',
  Croatia: '🇭🇷',
  Slovenia: '🇸🇮',
  Slovakia: '🇸🇰',
  Estonia: '🇪🇪',
  Latvia: '🇱🇻',
  Lithuania: '🇱🇹',
  Russia: '🇷🇺',
  Turkey: '🇹🇷',
  Egypt: '🇪🇬',
  Morocco: '🇲🇦',
  Tunisia: '🇹🇳',
  Algeria: '🇩🇿',
  Sudan: '🇸🇩',
  Ethiopia: '🇪🇹',
  Kenya: '🇰🇪',
  Tanzania: '🇹🇿',
  Uganda: '🇺🇬',
  Ghana: '🇬🇭',
  Nigeria: '🇳🇬',
  Senegal: '🇸🇳',
  Mali: '🇲🇱',
  'Burkina Faso': '🇧🇫',
  Niger: '🇳🇪',
  Chad: '🇹🇩',
  Cameroon: '🇨🇲',
  'Central African Republic': '🇨🇫',
  Congo: '🇨🇬',
  Angola: '🇦🇴',
  Zambia: '🇿🇲',
  Zimbabwe: '🇿🇼',
  Botswana: '🇧🇼',
  Namibia: '🇳🇦',
  Mozambique: '🇲🇿',
  Madagascar: '🇲🇬',
  Mauritius: '🇲🇺',
  Maldives: '🇲🇻',
  India: '🇮🇳',
  Pakistan: '🇵🇰',
  Bangladesh: '🇧🇩',
  'Sri Lanka': '🇱🇰',
  Nepal: '🇳🇵',
  Bhutan: '🇧🇹',
  Myanmar: '🇲🇲',
  Thailand: '🇹🇭',
  Cambodia: '🇰🇭',
  Vietnam: '🇻🇳',
  Malaysia: '🇲🇾',
  Singapore: '🇸🇬',
  Indonesia: '🇮🇩',
  Philippines: '🇵🇭',
  Brunei: '🇧🇳',
  Japan: '🇯🇵',
  'South Korea': '🇰🇷',
  'North Korea': '🇰🇵',
  Mongolia: '🇲🇳',
  Kazakhstan: '🇰🇿',
  Uzbekistan: '🇺🇿',
  Turkmenistan: '🇹🇲',
  Tajikistan: '🇹🇯',
  Kyrgyzstan: '🇰🇬',
  Afghanistan: '🇦🇫',
  Iran: '🇮🇷',
  Iraq: '🇮🇶',
  Syria: '🇸🇾',
  Lebanon: '🇱🇧',
  Jordan: '🇯🇴',
  Israel: '🇮🇱',
  Palestine: '🇵🇸',
  'Saudi Arabia': '🇸🇦',
  'United Arab Emirates': '🇦🇪',
  Qatar: '🇶🇦',
  Kuwait: '🇰🇼',
  Bahrain: '🇧🇭',
  Oman: '🇴🇲',
  Yemen: '🇾🇪',
  Australia: '🇦🇺',
  'New Zealand': '🇳🇿',
  'Papua New Guinea': '🇵🇬',
  Fiji: '🇫🇯',
  Vanuatu: '🇻🇺',
  'Solomon Islands': '🇸🇧',
  'New Caledonia': '🇳🇨',
  Canada: '🇨🇦',
  Greenland: '🇬🇱',
  Cuba: '🇨🇺',
  Jamaica: '🇯🇲',
  Haiti: '🇭🇹',
  'Dominican Republic': '🇩🇴',
  'Puerto Rico': '🇵🇷',
  'Trinidad and Tobago': '🇹🇹',
  Barbados: '🇧🇧',
  Bahamas: '🇧🇸',
  Belize: '🇧🇿',
  Guatemala: '🇬🇹',
  'El Salvador': '🇸🇻',
  Honduras: '🇭🇳',
  Nicaragua: '🇳🇮',
  'Costa Rica': '🇨🇷',
  Panama: '🇵🇦',
  Bolivia: '🇧🇴',
  Suriname: '🇸🇷',
  'French Guiana': '🇬🇫',
  Iceland: '🇮🇸',
  Luxembourg: '🇱🇺',
  Malta: '🇲🇹',
  Cyprus: '🇨🇾',
  Monaco: '🇲🇨',
  Liechtenstein: '🇱🇮',
  'San Marino': '🇸🇲',
  'Vatican City': '🇻🇦',
  'Bosnia and Herzegovina': '🇧🇦',
  'North Korea': '🇰🇵',
  Mauritania: '🇲🇷',
  Gambia: '🇬🇲',
  'Sierra Leone': '🇸🇱',
  Liberia: '🇱🇷',
  'Ivory Coast': '🇨🇮',
  Togo: '🇹🇬',
  Benin: '🇧🇯',
  'Equatorial Guinea': '🇬🇶',
  Gabon: '🇬🇦',
  'São Tomé and Príncipe': '🇸🇹',
  Rwanda: '🇷🇼',
  Burundi: '🇧🇮',
  Djibouti: '🇩🇯',
  Eritrea: '🇪🇷',
  Somalia: '🇸🇴',
  Malawi: '🇲🇼',
  Lesotho: '🇱🇸',
  Eswatini: '🇸🇿',
  Comoros: '🇰🇲',
  Seychelles: '🇸🇨',
  Armenia: '🇦🇲',
  Azerbaijan: '🇦🇿',
  Bahrain: '🇧🇭',
  Bangladesh: '🇧🇩',
  Barbados: '🇧🇧',
  Bahamas: '🇧🇸',
  Belize: '🇧🇿',
  Belgium: '🇧🇪',
  Benin: '🇧🇯',
  Bhutan: '🇧🇹',
  Bolivia: '🇧🇴',
  'Bosnia and Herzegovina': '🇧🇦',
  Botswana: '🇧🇼',
  Brazil: '🇧🇷',
  Brunei: '🇧🇳',
  Bulgaria: '🇧🇬',
  'Burkina Faso': '🇧🇫',
  Burundi: '🇧🇮',
  Cambodia: '🇰🇭',
  Cameroon: '🇨🇲',
  Canada: '🇨🇦',
  'Cape Verde': '🇨🇻',
  'Central African Republic': '🇨🇫',
  Chad: '🇹🇩',
  Chile: '🇨🇱',
  China: '🇨🇳',
  Colombia: '🇨🇴',
  Comoros: '🇰🇲',
  Congo: '🇨🇬',
  'Costa Rica': '🇨🇷',
  Croatia: '🇭🇷',
  Cuba: '🇨🇺',
  Cyprus: '🇨🇾',
  Czechia: '🇨🇿',
  Denmark: '🇩🇰',
  Djibouti: '🇩🇯',
  Dominica: '🇩🇲',
  'Dominican Republic': '🇩🇴',
  Ecuador: '🇪🇨',
  Egypt: '🇪🇬',
  'El Salvador': '🇸🇻',
  'Equatorial Guinea': '🇬🇶',
  Eritrea: '🇪🇷',
  Estonia: '🇪🇪',
  Eswatini: '🇸🇿',
  Ethiopia: '🇪🇹',
  Fiji: '🇫🇯',
  Finland: '🇫🇮',
  France: '🇫🇷',
  Gabon: '🇬🇦',
  Gambia: '🇬🇲',
  Georgia: '🇬🇪',
  Germany: '🇩🇪',
  Ghana: '🇬🇭',
  Greece: '🇬🇷',
  Grenada: '🇬🇩',
  Guatemala: '🇬🇹',
  Guinea: '🇬🇳',
  'Guinea-Bissau': '🇬🇼',
  Guyana: '🇬🇾',
  Haiti: '🇭🇹',
  Honduras: '🇭🇳',
  Hungary: '🇭🇺',
  Iceland: '🇮🇸',
  India: '🇮🇳',
  Indonesia: '🇮🇩',
  Iran: '🇮🇷',
  Iraq: '🇮🇶',
  Ireland: '🇮🇪',
  Israel: '🇮🇱',
  Italy: '🇮🇹',
  Jamaica: '🇯🇲',
  Japan: '🇯🇵',
  Jordan: '🇯🇴',
  Kazakhstan: '🇰🇿',
  Kenya: '🇰🇪',
  Kiribati: '🇰🇮',
  Kuwait: '🇰🇼',
  Kyrgyzstan: '🇰🇬',
  Laos: '🇱🇦',
  Latvia: '🇱🇻',
  Lebanon: '🇱🇧',
  Lesotho: '🇱🇸',
  Liberia: '🇱🇷',
  Libya: '🇱🇾',
  Liechtenstein: '🇱🇮',
  Lithuania: '🇱🇹',
  Luxembourg: '🇱🇺',
  Madagascar: '🇲🇬',
  Malawi: '🇲🇼',
  Malaysia: '🇲🇾',
  Maldives: '🇲🇻',
  Mali: '🇲🇱',
  Malta: '🇲🇹',
  'Marshall Islands': '🇲🇭',
  Mauritania: '🇲🇷',
  Mauritius: '🇲🇺',
  Mexico: '🇲🇽',
  Micronesia: '🇫🇲',
  Moldova: '🇲🇩',
  Monaco: '🇲🇨',
  Mongolia: '🇲🇳',
  Montenegro: '🇲🇪',
  Morocco: '🇲🇦',
  Mozambique: '🇲🇿',
  Myanmar: '🇲🇲',
  Namibia: '🇳🇦',
  Nauru: '🇳🇷',
  Nepal: '🇳🇵',
  Netherlands: '🇳🇱',
  'New Zealand': '🇳🇿',
  Nicaragua: '🇳🇮',
  Niger: '🇳🇪',
  Nigeria: '🇳🇬',
  'North Korea': '🇰🇵',
  'North Macedonia': '🇲🇰',
  Norway: '🇳🇴',
  Oman: '🇴🇲',
  Pakistan: '🇵🇰',
  Palau: '🇵🇼',
  Palestine: '🇵🇸',
  Panama: '🇵🇦',
  'Papua New Guinea': '🇵🇬',
  Paraguay: '🇵🇾',
  Peru: '🇵🇪',
  Philippines: '🇵🇭',
  Poland: '🇵🇱',
  Portugal: '🇵🇹',
  Qatar: '🇶🇦',
  Romania: '🇷🇴',
  Russia: '🇷🇺',
  Rwanda: '🇷🇼',
  'Saint Kitts and Nevis': '🇰🇳',
  'Saint Lucia': '🇱🇨',
  'Saint Vincent and the Grenadines': '🇻🇨',
  Samoa: '🇼🇸',
  'San Marino': '🇸🇲',
  'São Tomé and Príncipe': '🇸🇹',
  'Saudi Arabia': '🇸🇦',
  Senegal: '🇸🇳',
  Serbia: '🇷🇸',
  Seychelles: '🇸🇨',
  'Sierra Leone': '🇸🇱',
  Singapore: '🇸🇬',
  Slovakia: '🇸🇰',
  Slovenia: '🇸🇮',
  'Solomon Islands': '🇸🇧',
  Somalia: '🇸🇴',
  'South Africa': '🇿🇦',
  'South Korea': '🇰🇷',
  'South Sudan': '🇸🇸',
  Spain: '🇪🇸',
  'Sri Lanka': '🇱🇰',
  Sudan: '🇸🇩',
  Suriname: '🇸🇷',
  Sweden: '🇸🇪',
  Switzerland: '🇨🇭',
  Syria: '🇸🇾',
  Taiwan: '🇹🇼',
  Tajikistan: '🇹🇯',
  Tanzania: '🇹🇿',
  Thailand: '🇹🇭',
  'Timor-Leste': '🇹🇱',
  Togo: '🇹🇬',
  Tonga: '🇹🇴',
  'Trinidad and Tobago': '🇹🇹',
  Tunisia: '🇹🇳',
  Turkey: '🇹🇷',
  Turkmenistan: '🇹🇲',
  Tuvalu: '🇹🇻',
  Uganda: '🇺🇬',
  Ukraine: '🇺🇦',
  'United Arab Emirates': '🇦🇪',
  'United Kingdom': '🇬🇧',
  'United States': '🇺🇸',
  Uruguay: '🇺🇾',
  Uzbekistan: '🇺🇿',
  Vanuatu: '🇻🇺',
  'Vatican City': '🇻🇦',
  Venezuela: '🇻🇪',
  Vietnam: '🇻🇳',
  Yemen: '🇾🇪',
  Zambia: '🇿🇲',
  Zimbabwe: '🇿🇼',
};

/**
 * Get flag emoji for a country name
 * @param {string} countryName - Country name (in English preferred)
 * @returns {string} Flag emoji or empty string if not found
 */
export function getCountryFlag(countryName) {
  if (!countryName) return '';

  // Try exact match first
  if (countryFlagMap[countryName]) {
    return countryFlagMap[countryName];
  }

  // Try case-insensitive match
  const countryNameLower = countryName.toLowerCase();
  for (const [key, flag] of Object.entries(countryFlagMap)) {
    if (key.toLowerCase() === countryNameLower) {
      return flag;
    }
  }

  // Return empty string if no match found
  return '';
}

/**
 * Get flag emoji for a country object
 * @param {Object} country - Country object with country_name_en, country_name_es, or country_name
 * @returns {string} Flag emoji or empty string if not found
 */
export function getCountryFlagFromObject(country) {
  if (!country) return '';

  // Try country_name_en first
  if (country.country_name_en) {
    const flag = getCountryFlag(country.country_name_en);
    if (flag) return flag;
  }

  // Try country_name_es
  if (country.country_name_es) {
    const flag = getCountryFlag(country.country_name_es);
    if (flag) return flag;
  }

  // Try country_name
  if (country.country_name) {
    const flag = getCountryFlag(country.country_name);
    if (flag) return flag;
  }

  return '';
}
